import { defiItemFields } from '@/pages/defi-exposure/models/defi-fields'

export default {
  SET_SHOW_CREATE_EDIT_MODAL(state, payload) {
    state.showCreateEditModal = payload
  },
  SET_MODAL_ACTION(state, payload) {
    state.modalAction = payload
  },
  SET_CREATE_EDIT_MODAL_DATA(state, payload) {
    state.createEditModalData = payload
  },
  SET_INITIAL_CREATE_EDIT_MODAL_DATA(state) {    
    state.createEditModalData = defiItemFields()
  },
}
